export class WyreStormSw130Tx {
    constructor(socket) {
        this.socket = socket;
        this.firmwareVersion = ' EX0301_N008_A00 V1.4';
        this.videoMatrixRoutes = 'HDMI 1';
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /GET SW_VERSION/i,
                callback: (match) => {
                    this.socket.send(`${this.firmwareVersion}`);
                },
            },
            {
                name: 'videoMatrixRoutesQuery',
                regExp: /GET SW/i,
                callback: (match) => {
                    this.socket.send(`${this.videoMatrixRoutes}`);
                },
            },
            {
                name: 'videoMatrixRoutesSet',
                regExp: /SET SW (.+)/i,
                callback: (match) => {
                    this.videoMatrixRoutes = match[1];
                    this.socket.send(`${this.videoMatrixRoutes}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Error Command:${match[0]}`);
                },
            },
        ];
    }
}
WyreStormSw130Tx.emulatorType = 'socketEmulator';
WyreStormSw130Tx.key = '-Ms1SDpZBhT5-yUlb2Zf';
